export default __webpack_public_path__ + "static/media/p31.9d434a86.jpg";